import ColorSimpleView from './ColorSimpleView'

export default ColorSimpleView
